import gql from 'graphql-tag';

export const CouponListQuery = gql`
	query CouponListQuery(
		$first: Int
		$cursor: String
		$orderBy: CouponOrderBy
		$orderDesc: Boolean
		$filter: CouponFilterInput
	) {
		entities: coupons(
			first: $first
			after: $cursor
			orderBy: $orderBy
			orderDesc: $orderDesc
			filter: $filter
		) {
			edges {
				node {
					id
					localId
					name
					startDate
					expirationDate
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;
